var React = require('react');

function DowncaretWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.99999 1.4358e-05L10.8 0L12 1.16667L6.00001 7L0 1.16668L1.2 1.4358e-05L5.99999 1.4358e-05Z","fill":"white"}));
}

DowncaretWhite.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = DowncaretWhite;

DowncaretWhite.default = DowncaretWhite;
